import { ReactElement, ReactNode } from 'react';
import ReactTooltip from 'react-tooltip';
import { colors } from 'styles/colors';
import { InfoIconCR } from 'icons';

interface InfoTooltipProps {
  id: string;
  children: ReactNode;
  disabled?: boolean;
}

export function InfoTooltip({
  id,
  children,
  disabled,
}: Readonly<InfoTooltipProps>): ReactElement {
  return (
    <>
      <ReactTooltip
        id={`tooltip-${id}-info`}
        place="bottom"
        type="dark"
        effect="solid"
        delayHide={100}
        offset={{ top: 0, left: -2 }}
        backgroundColor={colors.bg['surface-700']}
        padding="4px"
        className="tooltip-bignumber"
        disable={disabled}
      >
        {children}
      </ReactTooltip>
      <div
        data-tip
        data-for={`tooltip-${id}-info`}
        style={{ width: 18, height: 18, display: 'flex' }}
      >
        <InfoIconCR />
      </div>
    </>
  );
}
